import _ from "lodash";
/** Internal */
import client from "lib/apolloClient/client";

import { getOrganizationStaffQuery } from "./StaffPerformanceQueries";

export const getOrganizationStaffFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationStaffQuery,
      variables,
    });
    return _.get(queryData, "node") || {};
  } catch (e) {
    return {};
  }
};
